import { Listing } from './listing.type';

type listingImage = {
    src: string;
    alt?: string;
};

export const getListingImage = (
    listing: Pick<Listing, 'image'>
): listingImage => {
    const listingImage: listingImage = {
        src: listing.image?.src || ''
    };

    if (listing.image?.caption) {
        listingImage.alt = listing.image.caption;
    }

    return listingImage;
};
